import type { User } from 'Types/user';
import getUserIdentityForTracking from 'Utilities/helpers/getUserIdentityForTracking';

import type { DatadogUser } from './datadog.types';

export const getDatadogUserFromSessionUser = (user: User): DatadogUser => {
	const id = user?.id?.toString(); // Datadog's setUser functions require a string for id
	return { ...getUserIdentityForTracking(user), id };
};
